export enum CountryCodesEnum {
  Uzbekistan = "UZB",
  Belarus = "BLR",
}
